/**
 * @generated SignedSource<<76095f5a920c6a58bdebda2c9c935c58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectWalletWithSigningContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EthereumConnectionZipCodeForm_viewer" | "WithWalletConnectionEnsuredModalBase_viewer">;
  readonly " $fragmentType": "ConnectWalletWithSigningContent_viewer";
};
export type ConnectWalletWithSigningContent_viewer$key = {
  readonly " $data"?: ConnectWalletWithSigningContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectWalletWithSigningContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectWalletWithSigningContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WithWalletConnectionEnsuredModalBase_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EthereumConnectionZipCodeForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "327b2e02a4d96d68fe4f818d7ad1f07e";

export default node;
